export default __webpack_public_path__ + "static/media/VERIFIER BUSY.a5ee75e3.mp3";